import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@/components/ui/skeleton";
import Footer from "../components/footer/Footer";
import Navbar from "../components/navbar/Navbar";
import { api } from "../services/group";
import { SetTheme } from "../hooks/theme";
import { useGroupData, useGroupLook } from "../stores/useGroupStore";
import { fonts, fontSizeToMultiplier } from "../lib/fonts";
import { Toaster } from "@/components/ui/sonner";
export default function App({ children }) {
    const { i18n } = useTranslation();
    const resultGroupLook = useQuery({
        queryKey: ["group-look"],
        queryFn: async () => {
            return api.group.look();
        },
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchInterval: false,
        refetchOnMount: true,
    });
    const resultGroupData = useQuery({
        queryKey: ["group-data"],
        queryFn: async () => {
            return api.group.data();
        },
        enabled: !!resultGroupLook.data,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchInterval: false,
        refetchOnMount: true,
    });
    React.useEffect(() => {
        if (localStorage.getItem("theme") != null) {
            SetTheme(Number(localStorage.getItem("theme")));
        }
    }, []);
    React.useEffect(() => {
        // Se l'utente non ha selezionato il tema preferito allora di default si utilizza quello del portale
        if (resultGroupLook.data && localStorage.getItem("theme") == null) {
            SetTheme(resultGroupLook.data.data.theme);
        }
        if (resultGroupLook.data) {
            document.documentElement.style.setProperty("--color-group-custom", resultGroupLook.data.data.secondary_color);
            const titleFont = fonts[resultGroupLook.data.data.font.title.family];
            titleFont.load();
            document.documentElement.style.setProperty("--title-font", titleFont.family);
            const genericFont = fonts[resultGroupLook.data.data.font.generic.family];
            genericFont.load();
            document.documentElement.style.setProperty("--generic-font", genericFont.family);
            const descriptionFont = fonts[resultGroupLook.data.data.font.description
                .family];
            descriptionFont.load();
            document.documentElement.style.setProperty("--description-font", descriptionFont.family);
            document.documentElement.style.setProperty("--title-size-multiplier", `${fontSizeToMultiplier(resultGroupLook.data.data.font.title.size)}`);
            document.documentElement.style.setProperty("--generic-size-multiplier", `${fontSizeToMultiplier(resultGroupLook.data.data.font.generic.size)}`);
            document.documentElement.style.setProperty("--description-size-multiplier", `${fontSizeToMultiplier(resultGroupLook.data.data.font.description.size)}`);
            i18n.changeLanguage(resultGroupLook.data.data.language);
        }
        // Store di GroupLook
        if (resultGroupLook.data) {
            useGroupLook.getState().setLook(resultGroupLook.data.data);
        }
    }, [resultGroupLook.data]);
    React.useEffect(() => {
        // Store di GroupData
        if (resultGroupData.data) {
            useGroupData.getState().setData(resultGroupData.data);
        }
    }, [resultGroupData.data]);
    return (_jsxs(_Fragment, { children: [_jsx(Toaster, {}), _jsxs("div", { className: "w-full", children: [_jsx(Navbar, {}), resultGroupData.data ? (children) : (_jsx(Skeleton, { className: "skeleton-custom h-[120vh] w-full rounded-none" })), _jsx(Footer, {})] })] }));
}
